import { Routes, Route } from "react-router-dom";
import { BalanceCashRequest } from "./list";

export function BalanceCashRequestRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BalanceCashRequest />} />
    </Routes>
  );
}
